import { kCBTextContent } from "../constants";

export class QClipboard {
  constructor() {
    this.fCBBuffer = null;
    this.fDoc = null;
  }

  SetDoc(theDoc) {
    this.fDoc = theDoc;
  }

  GetDoc() {
    return this.fDoc;
  }

  InitClipboard() {}

  SetContent(clipboardBuffer) {
    this.CleanupClipboard();
    this.fCBBuffer = clipboardBuffer;
  }

  GetContent() {
    var c = null;
    if (this.fCBBuffer) c = this.fCBBuffer.GetContent();

    return c;
  }

  GetContentType() {
    var cT = null;
    if (this.fCBBuffer) cT = this.fCBBuffer.GetContentType();

    return cT;
  }

  // Override to cleanup (e.g. objects in a database)
  DoCleanupClipboard() {}

  CleanupClipboard() {
    if (this.fCBBuffer == null) return;

    if (this.GetContentType() == kCBTextContent) return;

    this.DoCleanupClipboard();
    this.fCBBuffer = null;
  }
}
